import { render, staticRenderFns } from "./webpage.vue?vue&type=template&id=e81e64b0&"
import script from "./webpage.vue?vue&type=script&lang=js&"
export * from "./webpage.vue?vue&type=script&lang=js&"
import style0 from "./webpage.vue?vue&type=style&index=0&id=e81e64b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports